export default __webpack_public_path__ + "75bd2ee.png";